import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';

const api = new API();

function convertIncoming(data) {
  return data.map(item => {
    try {
      const parsedData = JSON.parse(item.data);
      return {
        ...item,
        data: parsedData
      };
    } catch(e) {
      return false;
    }
  }).filter(Boolean);
}

export const fetchSavedSearches = createAsyncThunk(
  'itemSearches/get',
  async (data, thunkAPI) => {
    try {
      const response = await api.getSavedSearches();
      if(response.status === 'ok') {
        return convertIncoming(response.result);
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: itemSearches/get', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const saveSearch = createAsyncThunk(
  'itemSearches/save',
  async (data, thunkAPI) => {
    try {
      const currentState = thunkAPI.getState();
      const response = await api.saveSearches([{data: data, itemOwner: currentState.itemOwners.selected}]);

      if(response.status === 'ok') {
        return convertIncoming(response.result);
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: itemSearches/save', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const deleteSearch = createAsyncThunk(
  'itemSearches/delete',
  async (searchId, thunkAPI) => {
    try {
      const response = await api.deleteSearch([{id: searchId}]);
      if(response.status === 'ok') {
        return convertIncoming(response.result);
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: itemSearches/delete', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  searches: [],
  fetchStatus: 'idle',
  fetchError: null,
  saveStatus: 'idle',
  saveError: null,
  deleteStatus: 'idle',
  deleteError: null
};


export const itemSearchesSlice = createSlice({
  name: 'itemSearches',
  initialState,
  reducers: {
    clearSaveStatus: (state, action) => {
      state.saveStatus = 'idle';
    },
    clearRequestState: (state, action) => {
      state.error = null;
      state.status = 'idle';
    },
    reset: (state, action) => {
      return initialState;
    }
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchSavedSearches.fulfilled]: (state, action) => {
      state.fetchStatus = 'succeeded';
      state.fetchError = null;
      state.searches = action.payload || [];
    },
    [fetchSavedSearches.pending]: (state, action) => {
      state.fetchStatus = 'loading';
      state.fetchError = null;
    },
    [fetchSavedSearches.rejected]: (state, action) => {
      state.fetchStatus = 'failed';
      state.fetchError = action.payload.messages.join(', ');
    },

    [saveSearch.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
      state.searches = action.payload || [];
    },
    [saveSearch.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [saveSearch.rejected]: (state, action) => {
      state.saveStatus = 'failed';
      state.saveError = action.payload.messages.join(', ');
    },

    [deleteSearch.fulfilled]: (state, action) => {
      state.deleteStatus = 'succeeded';
      state.deleteError = null;
      state.searches = action.payload || [];
    },
    [deleteSearch.pending]: (state, action) => {
      state.deleteStatus = 'loading';
      state.deleteError = null;
    },
    [deleteSearch.rejected]: (state, action) => {
      state.deleteStatus = 'failed';
      state.deleteError = action.payload;
    },
  }
});

export const { clearSaveStatus, clearRequestState, reset } = itemSearchesSlice.actions;

export const selectSaveStatus = state => ({
  status: state.itemSearches.saveStatus,
  error: state.itemSearches.saveError
});
export const selectSavedSearchesByOwner = state => ({
  searches: state.itemSearches.searches.filter(item => item.itemOwner === state.itemOwners.selected),
  status: state.itemSearches.fetchStatus,
  error: state.itemSearches.fetchError
});

export const selectSavedSearches = state => state.itemSearches;

export default itemSearchesSlice.reducer;
